import { render, staticRenderFns } from "./checkList.vue?vue&type=template&id=0b889e2f&scoped=true&"
import script from "./checkList.vue?vue&type=script&lang=js&"
export * from "./checkList.vue?vue&type=script&lang=js&"
import style0 from "./checkList.vue?vue&type=style&index=0&id=0b889e2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b889e2f",
  null
  
)

export default component.exports